import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "WarningAltInverted"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.79 2.59575C22.9107 2.3636 22.9016 2.08527 22.766 1.8615C22.6301 1.63717 22.387 1.5001 22.1247 1.5H2.6247C2.36275 1.5001 2.11984 1.63687 1.9839 1.86078C1.84796 2.08469 1.83869 2.3633 1.95945 2.59575L11.7094 21.3458C11.8512 21.5773 12.1032 21.7185 12.3747 21.7185C12.6462 21.7185 12.8982 21.5773 13.04 21.3458L22.79 2.59575ZM20.8895 3L12.3747 19.374L3.85998 3H20.8895ZM12 12.75C11.3787 12.75 10.875 13.2537 10.875 13.875C10.875 14.4963 11.3787 15 12 15C12.6213 15 13.125 14.4963 13.125 13.875C13.125 13.2537 12.6213 12.75 12 12.75ZM12.75 4.5H11.25V11.25H12.75V4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/WarningAltInverted.vue"]]);
